import React from "react";
import CustomFieldInput from "./CustomFieldInput";
import { isChampVisible } from "../../utils/customFields";

/**
 * Affiche une liste de champs personnalisés en respectant :
 * - La position (déjà triée par getApplicableChamps)
 * - La largeur (champ.width est un %, ex: "50", "100", "33")
 * - La visibilité conditionnelle des champs enfants (visibility_rule vs valeur du parent)
 *
 * Props:
 *   champs       - Tableau plat retourné par getApplicableChamps (avec _parentId)
 *   values       - Map { champId: valeur }
 *   onChange     - (champId, valeur) => void
 */
const CustomFieldsLayout = ({ champs, values, onChange }) => {
  if (!champs || champs.length === 0) return null;

  // Regrouper les champs en lignes en respectant la largeur cumulée.
  // Quand la somme des largeurs dépasse 100, on passe à la ligne suivante.
  const rows = [];
  let currentRow = [];
  let rowWidth = 0;

  champs.forEach(champ => {
    if (!isChampVisible(champ, values)) return;

    const width = Number(champ.width) || 100;

    if (rowWidth + width > 100 && currentRow.length > 0) {
      rows.push(currentRow);
      currentRow = [];
      rowWidth = 0;
    }

    currentRow.push(champ);
    rowWidth += width;
  });

  if (currentRow.length > 0) rows.push(currentRow);

  return (
    <>
      {rows.map((row, rowIdx) => (
        <div
          key={rowIdx}
          style={{ display: "flex", flexWrap: "wrap", gap: "0", margin: "0 -8px" }}
        >
          {row.map(champ => {
            const width = Number(champ.width) || 100;
            return (
              <div
                key={champ.id}
                style={{ width: `${width}%`, padding: "0 8px", boxSizing: "border-box" }}
              >
                <CustomFieldInput
                  champ={champ}
                  value={values[champ.id] ?? ""}
                  onChange={val => onChange(champ.id, val)}
                />
              </div>
            );
          })}
        </div>
      ))}
    </>
  );
};

export default CustomFieldsLayout;
